import { render, staticRenderFns } from "./MatchFieldsList.vue?vue&type=template&id=248bab94&"
import script from "./MatchFieldsList.vue?vue&type=script&lang=ts&"
export * from "./MatchFieldsList.vue?vue&type=script&lang=ts&"
import style0 from "./MatchFieldsList.vue?vue&type=style&index=0&lang=styl&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports